/*
  Sunne v2 – varukorgsvakt för paketsidorna. 14 oktober 2026.

  VARFÖR

  Paketets köpruta lägger tre sorters rader i samma anrop: paketraden med hela
  priset, ett 0-kronorsliftkort per person, och sedan 13 oktober en 0-kronorsrad
  per natt som bär rumslagret. Dokumentationen har sagt att anropet är atomärt –
  att ett 422 betyder att ingenting läggs i korgen.

  Det stämmer inte när raderna redan finns där. I test på boendet låg två rum i
  korgen, kunden försökte lägga fyra till på samma nätter när bara fyra fanns,
  och Shopify svarade 422 samtidigt som raderna utan lager (paketraden,
  liftkorten) gick igenom och nattraderna höjdes ända upp till taket. Kunden
  står då med ett paket utan täckning i rumslagret, och vi med en order vi inte
  kan hålla.

  VAD FILEN GÖR

  Den läser varukorgen precis innan ett POST till /cart/add går i väg och sparar
  antalet per radnyckel. Misslyckas anropet ställs korgen tillbaka till det
  läget: rader som tillkommit nollas, rader som höjts sänks. Lyckas anropet gör
  filen ingenting alls.

  Hjälpfunktionerna ligger i snippets/sunne-boende-lagg-i-korg.liquid, som
  renderas före den här filen.

  VARFÖR DEN LIGGER UTANFÖR PAKETSEKTIONEN

  sections/sunne-paket.liquid är över 50 kB och rörs ogillande. Samma väg
  användes 13 oktober för de spärrade datumen: data och skydd laddas från
  snippets/sunne-oppetdagar.liquid i stället. Där är filen också begränsad till
  produkter med taggen bekraftelse:paket, så ingen annan sida får sina anrop
  fördröjda – och framför allt rör vi inte IzyRents egna anrop på uthyrning,
  skidskola, bastu och ställplats.

  Boendets egen köpruta gör redan samma sak själv, med bättre felmeddelanden.
  Kör båda på samma anrop är det oförargligt: den andra återställningen hittar
  ingenting kvar att rätta.
*/
(function () {
  'use strict';

  if (window.sv2PaketKorgvaktLaddad) { return; }
  window.sv2PaketKorgvaktLaddad = true;

  function arAdd(url) {
    return String(url || '').indexOf('/cart/add') !== -1;
  }

  function harHjalp() {
    return !!(window.sv2KorgLas && window.sv2KorgAntalPerNyckel && window.sv2KorgAterstall);
  }

  /* XMLHttpRequest. Det riktiga send() skjuts upp tills varukorgen är läst –
     anroparen väntar ändå på load-händelsen, så fördröjningen syns inte. */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (metod, url) {
    try {
      this.__sv2Add = String(metod || '').toUpperCase() === 'POST' && arAdd(url);
    } catch (e) {
      this.__sv2Add = false;
    }
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var self = this;
    var args = arguments;
    if (!this.__sv2Add || !harHjalp()) { return origSend.apply(this, args); }

    window.sv2KorgLas(function (korg) {
      var fore = window.sv2KorgAntalPerNyckel(korg);
      self.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) { return; }
        window.sv2KorgAterstall(fore, function () {});
      });
      origSend.apply(self, args);
    });
  };

  /* fetch. Samma sak, men svaret lämnas vidare först när återställningen är
     klar, så att anroparens egen felhantering ser en städad varukorg. */
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (resurs, init) {
      var url = (typeof resurs === 'string') ? resurs : (resurs && resurs.url) || '';
      var metod = (init && init.method) || (resurs && resurs.method) || 'GET';
      if (String(metod).toUpperCase() !== 'POST' || !arAdd(url) || !harHjalp()) {
        return origFetch.apply(this, arguments);
      }
      var self = this;
      var args = arguments;
      return new Promise(function (klar, avbryt) {
        window.sv2KorgLas(function (korg) {
          var fore = window.sv2KorgAntalPerNyckel(korg);
          origFetch.apply(self, args).then(function (svar) {
            if (svar.ok) { klar(svar); return; }
            window.sv2KorgAterstall(fore, function () { klar(svar); });
          }, avbryt);
        });
      });
    };
  }
})();
